import PflegiaFriends from './PflegiaFriends.component';

export default PflegiaFriends;
